import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeActionKey extends TraitRegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
}
